var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "move-action-dialog-container" },
    [
      _c("CustomDialogHeaderComponent", {
        staticClass: "header",
        attrs: { headerTitle: _vm.text.title },
      }),
      !_vm.loadedSelectItems
        ? _c("SpinnerLayerComponent", { staticClass: "spinner-layer" })
        : _vm._e(),
      _c("LexonSelectComponent", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.loadedSelectItems,
            expression: "loadedSelectItems",
          },
        ],
        staticClass: "lexon-select",
        attrs: {
          id: "expedient",
          name: "expedient",
          label: _vm.text.label,
          keyName: "description",
          keyValue: "idExpedient",
          keyId: "idExpedient",
          returnObject: false,
          tableHeaders: _vm.tableHeaders,
          endPointEntity: _vm.expedientEndpointEntity,
        },
        on: { "emit-data-length": _vm.removeSpinner },
        model: {
          value: _vm.expedientId,
          callback: function ($$v) {
            _vm.expedientId = $$v
          },
          expression: "expedientId",
        },
      }),
      _vm.loadedSelectItems
        ? _c("CustomDialogActionButtonsComponent", {
            staticClass: "actions",
            attrs: {
              primaryButtonText: _vm.text.save,
              mainAction: _vm.moveAction,
              disabledButtons: !_vm.expedientId,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }